import { Fragment, useEffect, useState } from "react";
import { Button, Divider, Drawer, InputBase, makeStyles, MenuItem, Select, TextField } from "@material-ui/core";
import MenuIcon from '@material-ui/icons/Menu';
import { withStyles } from "@material-ui/styles";
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import clsx from 'clsx';
import { useTranslation } from "react-i18next";
import { changeLanguagePref } from "../../../utilities/language";
import i18n from "../../../i18n";
import { userLogout } from '../../../actions/userActions';
import FullscreenLoading from "../../FullscreenLoading";
import { useDispatch } from "react-redux";
import { getUSOrderAndSalaryDetaill, getUSOrderAndSalaryDetailPublic } from "../../../actions/driverMobileActions";
import { getOrdersAndSalary, getTeamOrdersAndSalary } from "../../../actions/driverMobileActionsCA";
import { sumCompletedOrders } from "../../../utilities/driverMobileIncome";
import { getIsTeamData } from "../../../utilities/common";
import { useHistory, useParams } from "react-router-dom";
import {
    normalizeDriverIdParam,
    buildDirectDeliveryStatementsPath,
    buildPerformanceBackUrl,
} from "../../../utilities/driverMobileDirectEntry";
import T4A from "../../T4A";
import PopUp from "../../T4A/Popup";
import { searchDriver } from "../../../actions/t4aActions";
import { showAlertSnackbar } from "../../../reducers/uiSlice";
import moment from "moment-timezone";

const useStyles = makeStyles((theme)=> ({
    root: {
        width: 315,
        marginTop: 22,
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    menuBurger: {
        height: 21.75,
        width: 29
    },
    overviewTitle: {
        height: 29,
        color: '#101820',
        fontSize: 24,
        fontWeight: 'bold',
        letterSpacing: 0,
        marginTop: 29
    },
    overViewUsername: {
        height: 21,
        color: '#101820',
        fontSize: 18,
        letterSpacing: 0,
        marginTop: 13
    },
    selectPeriod: {
        marginTop: 13,
        width: 313
    },
    selectedMenuItem: {
        backgroundColor: '#FFE5CD !important'
    },
    selectedMenuItemHistory: {
        backgroundColor: 'white !important'
    },
    overviewContent: {
        marginTop: 20,
        width: 313
    },
    overViewDate: {
        height: 21,
        opacity: 0.5,
        color: '#101820',
        fontSize: 18,
        fontWeight: 'bold',
        letterSpacing: 0
    },
    incomeTitle: {
        color: '#F68D2E',
        fontSize: 16,
        fontWeight: 500,
        letterSpacing: 0
    },
    incomeAmount: {
        color: '#F68D2E',
        fontSize: 40,
        fontWeight: 600,
        letterSpacing: 0
    },
    overviewTable: {
        marginTop: 22,
        borderTop: '3px solid #0D1923'
    },
    overviewTableRow: {
        backgroundColor: 'rgba(235,236,239,0.8)',
        padding: 11
    },
    overviewTableDetail: {
        display: 'flex',
        justifyContent: 'space-between',
        width: 290,
        paddingBottom: 7
    },
    overviewTableDescription: {
        height: 36,
        width: 313,
        color: '#686868',
        fontSize: 12,
        letterSpacing: 0,
        marginTop: 10
    },
    viewDetails: {
        marginTop: 32,
        marginLeft: 160,
        display: 'flex',
        alignItems: 'center'
    },
    viewDetailsText: {
        width: 129,
        color: '#F68D2E',
        fontSize: 18,
        fontWeight: 500,
        letterSpacing: 0,
        textAlign: 'center'
    },
    drawerStyle: {
        height: '90vh',
        opacity: 0.9,
        backgroundColor: '#101820',
        width: 215,
        padding: 30
    },
    menuTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        letterSpacing: 0,
        marginTop: 40
    },
    languageTitle: {
        height: 21,
        width: 82,
        opacity: 0.2,
        color: '#FFFFFF',
        fontSize: 18,
        fontWeight: 500,
        letterSpacing: 0,
        marginTop: 400
    },
    languageSelected: {
        color: '#FFFFFF',
        fontSize: 16,
        fontWeight: 'bold',
        letterSpacing: 0,
        borderBottom: '1px solid #FFFFFF',
        width: 'fit-content',
        marginTop: 24
    },
    language: {
        color: '#FFFFFF',
        fontSize: 16,
        fontWeight: 'bold',
        letterSpacing: 0,
        marginTop: 24
    },
    dateDownload: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    }
}))
const BootstrapInput = withStyles((theme) => ({
    root: {
        '& .MuiInputBase-input': {
            height: 23,
            width: 313,
            color: '#F68D2E',
            fontSize: 16,
            fontWeight: 500,
            letterSpacing: 0
        },
        '& .MuiSelect-icon': {
            color: '#F68D2E'
        }
    },
    input: {
        height: 44,
        width: 314,
        borderRadius: 7,
        backgroundColor: '#FFE5CD',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        paddingLeft: 13.5,
        paddingTop: 12,
        paddingRight: 88.5,
        paddingBottom: 10,
        '&:focus': {
            borderRadius: 4,
            boxShadow: '0 0 10px #fff'
        },
    }
}))(InputBase);

const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const monthNum = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

// ── US IncomeOverview ─────────────────────────────────────────────────────────
function IncomeOverviewUS(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const {t} = useTranslation('incomeOverview')
    const { driverId: rawDriverId } = useParams();
    const directEntryDriverId = normalizeDriverIdParam(rawDriverId);

    const [period, setPeriod] = useState(0);
    const [menuState, setMenuState] = useState(false);
    const [username, setUsername] = useState('');
    const [currentStart, setCurrentStart] = useState('');
    const [currentEnd, setCurrentEnd] = useState('');
    const [currentStartTime, setCurrentStartTime] = useState(0);
    const [currentEndTime, setCurrentEndTime] = useState(0);
    const [lastStart, setLastStart] = useState('');
    const [lastEnd, setLastEnd] = useState('');
    const [lastStartTime, setLastStartTime] = useState('');
    const [lastEndTime, setLastEndTime] = useState('');
    const [loading, setLoading] = useState(false);
    const [completedSum, setCompletedSum] = useState(0);
    const [menu, setMenu] = useState(window.localStorage.getItem('menu') || 0);
    const [t4aGenerated, setT4aGenerated] = useState(false);

    const handlePeriodChange = (event) => {
        setPeriod(event.target.value);
    };

    function toggleDrawer(open) {
        setMenuState(open);
    }

    function viewDetails() {
        window.localStorage.setItem('period', String(period));
        window.localStorage.setItem('menu', 0);
        if (period === 0) {
            window.localStorage.setItem('current-start-now', currentStart);
            window.localStorage.setItem('current-end-now', currentEnd);
            window.localStorage.setItem('current-start-time-now', currentStartTime);
            window.localStorage.setItem('current-end-time-now', currentEndTime);
        } else {
            window.localStorage.setItem('current-start', lastStart);
            window.localStorage.setItem('current-end', lastEnd);
            window.localStorage.setItem('current-start-time', lastStartTime);
            window.localStorage.setItem('current-end-time', lastEndTime);
        }
        if (rawDriverId) {
            history.push(buildDirectDeliveryStatementsPath(rawDriverId));
        } else {
            history.push('/driverMobile/deliveryStatements');
        }
    }

    useEffect(() => {
        window.localStorage.setItem('period', String(period));
    }, [period])
    useEffect(() => {
        if(window.localStorage.getItem('username')) {
            setUsername(window.localStorage.getItem('username'))
        }
    }, [window.localStorage.getItem('username')])
    useEffect(() => {
        const today = new Date();
        if(today && menu === 0) {
            let currentStartTime = 0;
            let currentEndTime = 0;
            let lastStartTime = 0;
            let lastEndTime = 0;
            let monthLastStartIndex = 0;
            let monthLastEndIndex = 0;
            let monthCurrentStartIndex = 0;
            let monthCurrentEndIndex = 0;
            let dateLastStartIndex = 0;
            let dateLastEndIndex = 0;
            let dateCurrentStartIndex = 0;
            let dateCurrentEndIndex = 0;
            let yearLastStartIndex = 0;
            let yearLastEndIndex = 0;
            let yearCurrentStartIndex = 0;
            let yearCurrentEndIndex = 0;
            let monthCurr = month[today.getMonth()];
            let monthLast = '';
            if(today.getMonth() - 1 < 0) {
                monthLast = month[month.length - 1];
            } else {
                monthLast = month[today.getMonth() - 1];
            }
            let currentEndInfo = monthCurr + ' ' + today.getDate();
            let currentStartInfo = monthCurr + ' ';
            let lastStartInfo = '';
            let lastEndInfo = '';
            if(Number(today.getDate() === 1)) {
                currentStartInfo = monthLast + ' ' + '16';
                lastStartInfo = monthLast + ' ' + '1';
                lastEndInfo = monthLast + ' ' + '16';

                monthCurrentEndIndex = today.getMonth();
                dateCurrentEndIndex = today.getDate();
                dateCurrentStartIndex = 16;
                dateLastStartIndex = 1;
                dateLastEndIndex = 16;
                yearCurrentEndIndex = today.getFullYear();
                if(today.getMonth() - 1 < 0) {
                    monthLastStartIndex = month.length - 1;
                    monthCurrentStartIndex = month.length - 1;
                    yearCurrentStartIndex = yearCurrentEndIndex - 1;
                    yearLastStartIndex = yearCurrentStartIndex;
                    yearLastEndIndex = yearLastStartIndex;
                } else {
                    monthLastStartIndex = today.getMonth() - 1;
                    monthCurrentStartIndex = today.getMonth() - 1;
                    yearCurrentStartIndex = yearCurrentEndIndex;
                    yearLastStartIndex = yearCurrentEndIndex;
                    yearLastEndIndex = yearLastStartIndex;
                }
                monthLastEndIndex = monthLastStartIndex;
            } else if(today.getDate() <= 16) {
                currentStartInfo += '1';
                lastStartInfo = monthLast + ' ' + '16';
                lastEndInfo = monthCurr + ' ' + '1';

                monthLastStartIndex = today.getMonth() - 1;
                monthLastEndIndex = today.getMonth();
                monthCurrentEndIndex = today.getMonth();
                monthCurrentStartIndex = monthCurrentEndIndex;
                dateCurrentEndIndex = today.getDate();
                dateCurrentStartIndex = 1;
                dateLastEndIndex = 1;
                dateLastStartIndex = 16;
                yearCurrentEndIndex = today.getFullYear();
                yearCurrentStartIndex = yearCurrentEndIndex;
                yearLastEndIndex = yearCurrentStartIndex;
                yearLastStartIndex = yearLastEndIndex;
                if(today.getMonth() - 1 < 0) {
                    monthLastStartIndex = month.length - 1;
                    yearLastEndIndex = yearCurrentStartIndex;
                    yearLastStartIndex = yearLastEndIndex - 1;
                }
            } else {
                currentStartInfo += '16';
                lastStartInfo = monthCurr + ' ' + '1';
                lastEndInfo = monthCurr + ' ' + '16';

                monthLastStartIndex = today.getMonth();
                monthLastEndIndex = today.getMonth();
                monthCurrentStartIndex = monthLastStartIndex;
                monthCurrentEndIndex = monthCurrentStartIndex;
                dateCurrentEndIndex = today.getDate();
                dateCurrentStartIndex = 16;
                dateLastStartIndex = 1;
                dateLastEndIndex = 16;
                yearCurrentEndIndex = today.getFullYear();
                yearCurrentStartIndex = yearCurrentEndIndex;
                yearLastStartIndex = yearCurrentStartIndex;
                yearLastEndIndex = yearLastStartIndex;
            }
            setCurrentStart(currentStartInfo);
            setCurrentEnd(currentEndInfo);
            setLastStart(lastStartInfo);
            setLastEnd(lastEndInfo);
            dateCurrentStartIndex = dateCurrentStartIndex < 10 ? '0' + dateCurrentStartIndex : dateCurrentStartIndex;
            dateCurrentEndIndex = dateCurrentEndIndex < 10 ? '0' + dateCurrentEndIndex : dateCurrentEndIndex;
            dateLastStartIndex = dateLastStartIndex < 10 ? '0' + dateLastStartIndex : dateLastStartIndex;
            dateLastEndIndex = dateLastEndIndex < 10 ? '0' + dateLastEndIndex : dateLastEndIndex;
            currentStartTime = yearCurrentStartIndex + '' + monthNum[monthCurrentStartIndex] + dateCurrentStartIndex;
            currentEndTime = yearCurrentEndIndex + '' + monthNum[monthCurrentEndIndex] + dateCurrentEndIndex;
            lastStartTime = yearLastStartIndex + '' + monthNum[monthLastStartIndex] + dateLastStartIndex;
            lastEndTime = yearCurrentEndIndex + '' + monthNum[monthLastEndIndex] + dateLastEndIndex;
            props.handleLastPeriod(lastStartInfo, lastEndInfo, lastStartTime, lastEndTime);
            window.localStorage.setItem('lastStart', lastStartInfo);
            window.localStorage.setItem('lastEnd', lastEndInfo);
            window.localStorage.setItem('lastStartTime', lastStartTime);
            window.localStorage.setItem('lastEndTime', lastEndTime);
            setCurrentStartTime(currentStartTime);
            setCurrentEndTime(currentEndTime);
            setLastStartTime(lastStartTime);
            setLastEndTime(lastEndTime);
            // In direct-entry mode only call the public (unauthenticated) endpoint,
            // and only when the driver ID is a valid number. Non-numeric params
            // (e.g. "demo") render the UI without making any API call so the
            // authenticated-endpoint interceptor never fires and reloads the page.
            const isDirectEntry = !!rawDriverId;
            const shouldFetch = isDirectEntry ? !!directEntryDriverId : props.open;
            if(shouldFetch) {
                const fromDate = period === 0 ? currentStartTime : lastStartTime;
                const toDate = period === 0 ? currentEndTime : lastEndTime;
                if(fromDate && toDate) {
                    setLoading(true);
                    const from = `${String(fromDate).substring(0, 4)}-${String(fromDate).substring(4, 6)}-${String(fromDate).substring(6, 8)}`;
                    const to = `${String(toDate).substring(0, 4)}-${String(toDate).substring(4, 6)}-${String(toDate).substring(6, 8)}`;
                    const fetchAction = directEntryDriverId
                        ? getUSOrderAndSalaryDetailPublic(directEntryDriverId, from, to)
                        : getUSOrderAndSalaryDetaill(from, to);
                    dispatch(fetchAction)
                        .then((res) => {
                            setLoading(false);
                            setCompletedSum(sumCompletedOrders(res || []));
                        })
                        .catch(() => setLoading(false));
                }
            }
        }
    }, [props.open, period, menu, rawDriverId, directEntryDriverId])
    useEffect(() => {
        setMenu(Number(window.localStorage.getItem('menu')));
    }, [window.localStorage])
    useEffect(() => {
        if(menu === 1) {
            setT4aGenerated(false);
            dispatch(searchDriver(window.localStorage.getItem('driver_id')))
            .then((res) => {
                if(!res) {
                    dispatch(showAlertSnackbar({message: 'T4A is not generated!'}));
                    setT4aGenerated(false);
                    setMenu(0);
                    console.log(res)
                } else {
                    setT4aGenerated(true);
                }
            })
            .catch(() => {
                dispatch(showAlertSnackbar({message: 'T4A is not generated!'}));
                setT4aGenerated(false);
                setMenu(0);
            })
        }
    }, [menu])

    return (
        <div>
            {
                menu === 0 &&
                <div className={classes.root}>
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        {rawDriverId ? (
                            <a
                                href={buildPerformanceBackUrl(rawDriverId) || '#'}
                                style={{color: '#101820', fontSize: 14, textDecoration: 'none', display: 'flex', alignItems: 'center'}}
                                aria-label="Back to performance page"
                            >
                                ← Back
                            </a>
                        ) : (
                            <MenuIcon
                                fontSize='large'
                                onClick={()=>{
                                    toggleDrawer(true)
                                }}
                            />
                        )}
                    </div>
                    <div className={classes.overviewTitle}>{t('title')}</div>
                    <div className={classes.overViewUsername}>{username}</div>
                    <div className={classes.selectPeriod}>
                        <Select
                            fullWidth
                            value={period}
                            onChange={handlePeriodChange}
                            input={<BootstrapInput />}
                            MenuProps={{
                                anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left"
                                },
                                transformOrigin: {
                                vertical: "top",
                                horizontal: "left"
                                },
                                getContentAnchorEl: null
                            }}
                        >
                            <MenuItem
                                value={0}
                                classes={{selected: classes.selectedMenuItem}}
                                style={{
                                    height: 44,
                                    width: 295,
                                    borderRadius: 7,
                                    margin: 10
                                }}
                            >
                                {t('current_payment')}
                            </MenuItem>
                            <MenuItem
                                value={1}
                                classes={{selected: classes.selectedMenuItem}}
                                style={{
                                    height: 44,
                                    width: 295,
                                    borderRadius: 7,
                                    margin: 10
                                }}
                            >
                                {t('last_payment')}
                            </MenuItem>
                        </Select>
                    </div>
                    <div className={classes.overviewContent}>
                        <div className={classes.overViewDate}>
                            {period === 0 ? `${currentStart} - ${currentEnd}` : `${lastStart} - ${lastEnd}`}
                        </div>
                        <div style={{display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginTop: 33}}>
                            <span className={classes.incomeTitle}>{t('completed_orders')}:</span>
                            <span className={classes.incomeAmount}>{completedSum}</span>
                        </div>
                        <div className={classes.viewDetails} onClick={viewDetails}>
                            <div className={classes.viewDetailsText}>{t('delivery_details')}</div>
                            <ArrowRightAltIcon style={{color: "#F68D2E"}}/>
                        </div>
                    </div>
                </div>
            }
            {
                menu === 1 &&
                t4aGenerated &&
                <div>
                    <div style={{marginLeft:20, marginTop: 22}}>
                        <MenuIcon
                            fontSize='large'
                            onClick={()=>{
                                toggleDrawer(true)
                            }}
                        />
                    </div>
                    <T4A/>
                </div>

            }
            <Drawer anchor='left' open={menuState} onClose={()=>toggleDrawer(false)}>
                <div
                    className={classes.drawerStyle}
                    onClick={()=>toggleDrawer(false)}
                    onKeyDown={()=>toggleDrawer(false)}
                >
                    <div>
                        <MenuIcon
                            fontSize='large'
                            style={{color: "#F68D2E"}}
                        />
                    </div>
                    <div
                        className={classes.menuTitle}
                        onClick={() => {
                            setMenu(0);
                            window.localStorage.setItem('menu', 0);
                        }}
                        style={
                            menu === 0 ?
                            {color: '#EA882D'} :
                            {color: 'white'}
                        }
                    >
                        {t('title')}
                    </div>
                    {/* Hide T4A */}
                    {/* <div
                        className={classes.menuTitle}
                        onClick={() => {
                            setMenu(1);
                            window.localStorage.setItem('menu', 1);
                        }}
                        style={
                            menu === 1 ?
                            {color: '#EA882D'} :
                            {color: 'white'}
                        }
                    >
                        T4A
                    </div> */}
                    <div className={classes.languageTitle}>
                        {t('language')}
                    </div>
                    {/* <div
                        className={classes.language}
                        style={
                            i18n.language==='cn' ?
                            {
                                borderBottom: '1px solid #FFFFFF',
                                width: 'fit-content'
                            }:{
                                border: 'none'
                            }
                        }
                        onClick={() => changeLanguagePref(i18n, "cn")}
                    >
                        中文
                    </div> */}
                    <div
                        className={classes.language}
                        style={
                            i18n.language==='en' ?
                            {
                                borderBottom: '1px solid #FFFFFF',
                                width: 'fit-content'
                            }:{
                                border: 'none'
                            }
                        }
                        onClick={() => changeLanguagePref(i18n, "en")}
                    >
                        English
                    </div>
                    {/* <div
                        className={classes.language}
                        style={
                            i18n.language==='fr' ?
                            {
                                borderBottom: '1px solid #FFFFFF',
                                width: 'fit-content'
                            }:{
                                border: 'none'
                            }
                        }
                        onClick={() => changeLanguagePref(i18n, "fr")}
                    >
                        Français
                    </div> */}
                </div>
                <Divider/>
                <div
                    style={{
                        height: '10vh',
                        opacity: 0.9,
                        backgroundColor: '#101820',
                        width: 215,
                        padding: 30
                    }}
                >
                    <div style={{
                        color: '#FFFFFF',
                        fontSize: 16,
                        fontWeight: 'bold',
                        letterSpacing: 0
                        }}
                        onClick={()=>userLogout(true)}
                    >
                        {t('log_out')}
                    </div>
                </div>
            </Drawer>
            <FullscreenLoading open={loading} />
        </div>
    )
}

// ── Canada IncomeOverview (new — do not modify US code above) ─────────────────
function IncomeOverviewCA(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const {t} = useTranslation('incomeOverview');

    const [period, setPeriod] = useState(0);
    const [showDrawer, setShowDrawer] = useState(false);
    const [username, setUsername] = useState('');
    const [currentStart, setCurrentStart] = useState('');
    const [currentEnd, setCurrentEnd] = useState('');
    const [currentStartTime, setCurrentStartTime] = useState(0);
    const [currentEndTime, setCurrentEndTime] = useState(0);
    const [lastStart, setLastStart] = useState('');
    const [lastEnd, setLastEnd] = useState('');
    const [lastStartTime, setLastStartTime] = useState('');
    const [lastEndTime, setLastEndTime] = useState('');
    const [loading, setLoading] = useState(false);
    const [style, setStyle] = useState(2);
    const [popupOpen, setPopupOpen] = useState(false);
    const [isTeamLeader, setIsTeamLeader] = useState(false);
    const [isTeamData, setIsTeamData] = useState(getIsTeamData());
    const [showIncome, setShowIncome] = useState(false);
    const [completed, setCompleted] = useState();
    const [overweightOrders, setOverweightOrders] = useState();
    const [overweightAmount, setOverweightAmount] = useState();
    const [allowance, setAllowance] = useState();
    const [amount, setAmount] = useState();

    function viewDetails() {
        window.localStorage.setItem('current-start-now', currentStart);
        window.localStorage.setItem('current-end-now', currentEnd);
        window.localStorage.setItem('current-start-time-now', currentStartTime);
        window.localStorage.setItem('current-end-time-now', currentEndTime);
        history.push('/driverMobile/deliveryStatements');
    }

    useEffect(() => {
        window.localStorage.setItem('period', period);
        if (period === 2) history.push('/driverMobile/incomeStatements');
    }, [history, period]);

    useEffect(() => {
        const storedUsername = window.localStorage.getItem('username');
        if (storedUsername) setUsername(storedUsername);
    }, []);

    useEffect(() => {
        const current = moment();
        let currentStartMoment, currentEndMoment, lastStartMoment, lastEndMoment;

        if (current.date() <= 15) {
            currentStartMoment = current.clone().date(1);
            currentEndMoment = current.clone();
            lastStartMoment = current.clone().subtract(1, 'month').date(16);
            lastEndMoment = current.clone().subtract(1, 'month').endOf('month');
        } else {
            currentStartMoment = current.clone().date(16);
            currentEndMoment = current.clone();
            lastStartMoment = current.clone().date(1);
            lastEndMoment = current.clone().date(15);
        }

        // Backend: add 1 day to end (exclusive end date for table naming)
        const currentStartTime = currentStartMoment.format('YYYYMMDD');
        const currentEndTime = currentEndMoment.clone().add(1, 'day').format('YYYYMMDD');
        const lastStartTime = lastStartMoment.format('YYYYMMDD');
        const lastEndTime = lastEndMoment.clone().add(1, 'day').format('YYYYMMDD');

        setCurrentStart(currentStartMoment.format('MMM D'));
        setCurrentEnd(currentEndMoment.format('MMM D'));
        setCurrentStartTime(currentStartTime);
        setCurrentEndTime(currentEndTime);
        setLastStart(lastStartMoment.format('MMM D'));
        setLastEnd(lastEndMoment.format('MMM D'));
        window.localStorage.setItem('lastStart', lastStartMoment.format('MMM D'));
        window.localStorage.setItem('lastEnd', lastEndMoment.format('MMM D'));
        window.localStorage.setItem('lastStartTime', lastStartTime);
        window.localStorage.setItem('lastEndTime', lastEndTime);
        setLastStartTime(lastStartTime);
        setLastEndTime(lastEndTime);

        if (props.open) {
            setLoading(true);
            const getFunc = isTeamData ? getTeamOrdersAndSalary : getOrdersAndSalary;
            const fromTime = period === 0 ? currentStartTime : lastStartTime;
            const toTime = period === 0 ? currentEndTime : lastEndTime;
            if (fromTime && toTime) {
                dispatch(getFunc(fromTime, toTime))
                    .then(res => {
                        const driver = res.driverinfo;
                        const data = res.data;
                        window.localStorage.setItem('email', driver.email);
                        setIsTeamLeader(Boolean(driver.team_leader));
                        setShowIncome(isTeamData ? true : driver.show_salary);
                        setAmount(data.amt);
                        setCompleted(data.completed);
                        setOverweightOrders(data.overweight);
                        setOverweightAmount(data.owamt);
                        setAllowance(data.amt_adj);
                        setLoading(false);
                    })
                    .catch(() => setLoading(false));
            } else {
                setLoading(false);
            }
        }
    }, [props.open, period, isTeamData, dispatch]);

    return (
        <div>
            <div className={classes.root}>
                <div>
                    <MenuIcon fontSize='large' onClick={() => setShowDrawer(true)} />
                </div>
                <div className={classes.overviewTitle}>
                    {isTeamData ? t('team_overview') : t('title')}
                </div>
                <div className={classes.overViewUsername}>{username}</div>
                <div className={classes.selectPeriod}>
                    <Select
                        fullWidth
                        value={period}
                        onChange={e => setPeriod(e.target.value)}
                        input={<BootstrapInput />}
                        MenuProps={{
                            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                            transformOrigin: { vertical: 'top', horizontal: 'left' },
                            getContentAnchorEl: null
                        }}
                    >
                        <MenuItem value={0} classes={{selected: classes.selectedMenuItem}} style={{height: 44, width: 295, borderRadius: 7, margin: 10}}>
                            {t('current_payment')}
                        </MenuItem>
                        <MenuItem value={1} classes={{selected: classes.selectedMenuItem}} style={{height: 44, width: 295, borderRadius: 7, margin: 10}}>
                            {t('last_payment')}
                        </MenuItem>
                        <MenuItem value={2} classes={{selected: classes.selectedMenuItemHistory}} style={{height: 44, width: 295, margin: 10, paddingTop: 10, borderTop: '1px solid rgba(16,24,32,0.2)'}}>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <MonetizationOnIcon style={{marginRight: 12}} />
                                <div style={{marginRight: 5}}>{t('history_income')}</div>
                                <ArrowRightAltIcon />
                            </div>
                        </MenuItem>
                    </Select>
                </div>
                <div className={classes.overviewContent}>
                    {period === 0 && (
                        <div className={classes.overViewDate}>{currentStart} - {currentEnd}</div>
                    )}
                    {period === 1 && (
                        <div className={classes.dateDownload}>
                            <div className={classes.overViewDate}>{lastStart} - {lastEnd}</div>
                            <Button
                                style={{
                                    backgroundColor: 'white',
                                    height: 25,
                                    border: '2px solid rgba(16,24,32,0.3)',
                                    borderRadius: 12.5,
                                    color: '#101820',
                                    fontSize: 12,
                                    fontWeight: 'bold',
                                    letterSpacing: 0,
                                    paddingTop: 6,
                                    paddingBottom: 6,
                                    paddingLeft: 9,
                                    paddingRight: 9
                                }}
                                onClick={() => { setStyle(2); setPopupOpen(true); }}
                            >
                                {t('download')}
                            </Button>
                        </div>
                    )}
                    {period === 0 && (
                        <div>
                            {showIncome && (
                                <div style={{display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginTop: 33}}>
                                    <span className={classes.incomeTitle}>{t('estimated_income')}</span>
                                    <span className={classes.incomeAmount}>{amount ? `$${Number(amount).toFixed(2)}` : '$0'}</span>
                                </div>
                            )}
                            <div className={classes.overviewTable}>
                                <div className={classes.overviewTableRow}>
                                    <div className={classes.overviewTableDetail} style={{borderBottom: '1px solid #8A8B8A'}}>
                                        <div>{t('completed_orders')}</div>
                                        <div>{completed}</div>
                                    </div>
                                </div>
                                <div className={classes.overviewTableRow}>
                                    <div className={classes.overviewTableDetail} style={{borderBottom: '1px solid #8A8B8A'}}>
                                        <div>{t('overweight_orders')}</div>
                                        <div>{overweightOrders}</div>
                                    </div>
                                </div>
                                <div className={classes.overviewTableRow}>
                                    <div className={classes.overviewTableDetail} style={{borderBottom: '1px solid #8A8B8A'}}>
                                        <div>{t('overweight_amount')}</div>
                                        <div>{overweightAmount}</div>
                                    </div>
                                </div>
                                <div className={classes.overviewTableRow}>
                                    <div className={classes.overviewTableDetail}>
                                        <div>{t('allowance_deduction')}</div>
                                        <div>{allowance}</div>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.overviewTableDescription}>{t('notice')}</div>
                            <div className={classes.viewDetails} onClick={viewDetails}>
                                <div className={classes.viewDetailsText}>{t('delivery_details')}</div>
                                <ArrowRightAltIcon style={{color: '#F68D2E'}} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Drawer anchor='left' open={showDrawer} onClose={() => setShowDrawer(false)}>
                <div
                    className={classes.drawerStyle}
                    style={{display: 'flex', flexDirection: 'column'}}
                    onClick={() => setShowDrawer(false)}
                    onKeyDown={() => setShowDrawer(false)}
                >
                    <div>
                        <MenuIcon fontSize='large' style={{color: '#F68D2E'}} />
                    </div>
                    <div
                        className={classes.menuTitle}
                        onClick={() => {
                            setIsTeamData(false);
                            window.localStorage.setItem('overview', 'driver');
                        }}
                        style={!isTeamData ? {color: '#EA882D'} : {color: 'white'}}
                    >
                        {t('title')}
                    </div>
                    {isTeamLeader && (
                        <div
                            className={classes.menuTitle}
                            onClick={() => {
                                setIsTeamData(true);
                                window.localStorage.setItem('overview', 'team');
                            }}
                            style={isTeamData ? {color: '#EA882D'} : {color: 'white'}}
                        >
                            {t('team_overview')}
                        </div>
                    )}
                    <div className={classes.languageTitle} style={{marginTop: 'auto'}}>
                        {t('language')}
                    </div>
                    <div
                        className={classes.language}
                        onClick={() => changeLanguagePref(i18n, 'en')}
                        style={i18n.language === 'en' ? {borderBottom: '1px solid #FFFFFF', width: 'fit-content'} : {border: 'none'}}
                    >
                        English
                    </div>
                </div>
                <Divider />
                <div style={{height: '10vh', opacity: 0.9, backgroundColor: '#101820', width: 215, padding: 30}}>
                    <div
                        style={{color: '#FFFFFF', fontSize: 16, fontWeight: 'bold', letterSpacing: 0}}
                        onClick={() => userLogout(true)}
                    >
                        {t('log_out')}
                    </div>
                </div>
            </Drawer>
            <FullscreenLoading open={loading} />
            <PopUp
                style={style}
                open={popupOpen}
                handlePopupClose={() => setPopupOpen(false)}
                type='income'
                isTeamData={isTeamData}
                timeStart={lastStartTime}
                timeEnd={lastEndTime}
            />
        </div>
    )
}

const IncomeOverview = import.meta.env.VITE_COUNTRY === 'CA'
    ? IncomeOverviewCA
    : IncomeOverviewUS;

export default IncomeOverview;
